import { IGaUser } from '../../types/user/gaUser';
import { IUser } from '../../types/user/user';
import { NOT_AUTHORIZED_GA_USER } from '../../constants';

export function createGaUser(user: IUser): IGaUser {
  if (!user.isAuthenticated) {
    return NOT_AUTHORIZED_GA_USER;
  }

  const { id: cianUserId, userType: type, tariff: tarif, balance, userId } = user;

  return {
    type,
    cianUserId,
    tarif,
    balance,
    userId,
  };
}
